import React, { useEffect, useState } from "react";
import L from "leaflet"; // Импорт библиотеки Leaflet
import "leaflet-draw/dist/leaflet.draw.css";
import "leaflet/dist/leaflet.css";
import { MapContainer, Marker, Popup, TileLayer, GeoJSON } from "react-leaflet";
import { getCookie } from "typescript-cookie";
import KyLokal from "../../changeLang/drawLocalesKy";
import RuLokal from "../../changeLang/drawLocalesRu";
import styles from "./styles_map.module.css";

interface IContentPart {
  latitude: number;
  longitude: number;
}

const markers = [
  {
    latitude: 42.7904366,

    longitude: 74.7902057,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ИП "Джапаров Шарше"</h3>
      <p style="margin: 4px 0;">
        <strong>ФИО:</strong> Джапаров Шарше<br />
        <strong>Наименование культур:</strong> Яблони, Черешни<br />
        <strong>Площадь питомника, га:</strong> 17<br />
        <strong>Локация:</strong> Иссык-Атинский р-н, 
с. Чон- Далы <br />
      </p>
      </div>
    `,
  },
  {
    latitude: 42.8070675,

    longitude: 74.5216099,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ИП "Никита"</h3>
      <p style="margin: 4px 0;">
        <strong>ФИО:</strong> Коновалов Денис<br />
        <strong>Наименование культур:</strong> Яблони, Черешни, Абрикос, Слива, Персик, Груша, <br />
        <strong>Площадь питомника, га:</strong> 34<br />
        <strong>Локация:</strong> Сокулукский р-н, с. Верхний Орок<br />
      </p>
      </div>
    `,
  },
  {
    latitude: 42.9645553,

    longitude: 74.7729104,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">КФХ «Бекхан Агро»</h3>
      <p style="margin: 4px 0;">
        <strong>ФИО:</strong> Эркибаев Анвар<br />
        <strong>Наименование культур:</strong> Яблони, Черешни, Айва , Груша, Абрикос , Персик , Хурма, Черная и красная смородина, Ежевика , Малина   <br />
        <strong>Площадь питомника, га:</strong> 17<br />
        <strong>Локация:</strong> Иссык-Атинский р-н, с. Милянфан<br />
      </p>
      </div>
    `,
  },
  {
    latitude: 42.3495338,

    longitude: 77.9989435,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ИП «Окенов Марат Таалайбекович»</h3>
      <p style="margin: 4px 0;">
        <strong>ФИО:</strong> Окенов Марат<br />
        <strong>Наименование культур:</strong> Яблони, Груша ,Смородина , Облепиха, Малина<br />
        <strong>Площадь питомника, га:</strong> 57<br />
        <strong>Локация:</strong> Джети-Огузский р-н, АО Кызыл-Суу, уч. Кара-Булун<br />
      </p>
      </div>
    `,
  },
  {
    latitude: 42.3215126,

    longitude: 77.9357687,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ОсОО «Узак Групп»</h3>
      <p style="margin: 4px 0;">
        <strong>ФИО:</strong> Мажиков Азамат<br />
        <strong>Наименование культур:</strong> Смородина , Облепиха<br />
        <strong>Площадь питомника, га:</strong> 70<br />
        <strong>Локация:</strong> Джети -Огузский р-н, АО Саруу, с. Саруу, ул. Мамажан, 23<br />
      </p>
      </div>
    `,
  },
  {
    latitude: 42.1644772,

    longitude: 77.6106085,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">СК «Барскоонский плодопитомник»</h3>
      <p style="margin: 4px 0;">
        <strong>ФИО:</strong> Шаршеев Нурлан<br />
        <strong>Наименование культур:</strong> Смородина , Облепиха, Груша ,Черешня, Малина <br />
        <strong>Площадь питомника, га:</strong> 34<br />
        <strong>Локация:</strong> Джети-Огузский р-н, Барскоон АО, с. Барскон, квартал 3, дом 1<br />
      </p>
      </div>
    `,
  },
  {
    latitude: 42.1904401,

    longitude: 77.6105974,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">КФХ «Таара»</h3>
      <p style="margin: 4px 0;">
        <strong>ФИО:</strong> Тюлегенов Табалды<br />
        <strong>Наименование культур:</strong> Груши , Яблони, Абрикосы ,Персик, Малина, Смородина <br />
        <strong>Площадь питомника, га:</strong> 4<br />
        <strong>Локация:</strong> Джети-Огузский р-н, Барскоон АО, с. Барскоон<br />
      </p>
      </div>
    `,
  },

  {
    latitude: 40.5629976,

    longitude: 72.7547637,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">КФХ «Асатулла Ата»</h3>
      <p style="margin: 4px 0;">
        <strong>ФИО:</strong> Кадыров Немат<br />
        <strong>Наименование культур:</strong> Яблони, Черешня ,Персик ,Абрикос ,Груша <br />
        <strong>Площадь питомника, га:</strong> 6<br />
        <strong>Локация:</strong> Кара-Сууйский р-н, Нариман АА, с. Нариман, ул. Алишер Навоий 2 и Кызыл Кыштак АА, ул. Коммунистическая, 2<br />
      </p>
      </div>
    `,
  },

  {
    latitude: 40.211624,

    longitude: 72.7043616,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">КФХ «Наниш»</h3>
      <p style="margin: 4px 0;">
        <strong>ФИО:</strong> Каримов Абдимитал<br />
        <strong>Наименование культур:</strong> Яблони<br />
        <strong>Площадь питомника, га:</strong> 3,5<br />
        <strong>Локация:</strong> Ноокатский р-н, с. Ак Булак<br />
      </p>
      </div>
    `,
  },
  {
    latitude: 40.233874,

    longitude: 71.9542289,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">СППК «Арпасай Береке багы»</h3>
      <p style="margin: 4px 0;">
        <strong>ФИО:</strong> Юлдашев Ысман<br />
        <strong>Наименование культур:</strong> Яблони , Черешня, Персик , Хурма, Айва, Груша, Слива<br />
        <strong>Площадь питомника, га:</strong> 6<br />
        <strong>Локация:</strong> Кадамжайский р-н, Марказский  АО, с. Арпа-Сай<br />
      </p>
      </div>
    `,
  },
  {
    latitude: 40.211624,

    longitude: 72.7043616,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">КФХ «Наниш»</h3>
      <p style="margin: 4px 0;">
        <strong>ФИО:</strong> Каримов Абдимитал<br />
        <strong>Наименование культур:</strong> Яблони<br />
        <strong>Площадь питомника, га:</strong> 3,5<br />
        <strong>Локация:</strong> Ноокатский р-н, с. Ак Булак<br />
      </p>
      </div>
    `,
  },
  {
    latitude: 42.8207042,
   longitude: 73.8516114,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Эргешов Алтынбек</h3>
      <p style="margin: 4px 0;">
        <strong>Наименование культур:</strong> Фрукты<br />
        <strong>Наименование вида:</strong> яблоки<br />
        <strong>Площадь питомника, га:</strong> 10<br />
        <strong>Локация:</strong> Чуйская область, Жайыльский район, Кара-Балта<br />
      </p>
      </div>
    `,
  },
  {
    latitude: 40.2347101,
   longitude: 71.4951906,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Акбаров Шералы</h3>
      <p style="margin: 4px 0;">
        <strong>Наименование культур:</strong> Фрукты<br />
        <strong>Наименование вида:</strong> персики, яблоки и сливы <br />
        <strong>Площадь питомника, га:</strong> 12<br />
        <strong>Локация:</strong> Баткенская область, Кадамжайский район, село Алга, ул.Топгоркон, 18<br />
      </p>
      </div>
    `,
  },
  {
    latitude: 40.1541082,
   longitude: 70.8112868,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">СБК «Алыш-Дан Органик»</h3>
      <p style="margin: 4px 0;">
        <strong>Наименование культур:</strong> Фрукты<br />
        <strong>Наименование вида:</strong> абрикос <br />
        <strong>Площадь питомника, га:</strong> 125<br />
        <strong>Локация:</strong> Баткенская область, Баткенский район, Кара-Бак АО, с. Кара-Бак, Сары-Булак, 63<br />
      </p>
      </div>
    `,
  },

  {
    latitude: 42.388543,
   longitude: 78.2216503,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">ИП «Төлөгөнөв Улан»</h3>
      <p style="margin: 4px 0;">
        <strong>Наименование культур:</strong> Ягоды, Фрукты<br />
        <strong>Наименование вида:</strong> блоки, черешня, абрикос, смородина и малина <br />
        <strong>Площадь питомника, га:</strong> 18<br />
        <strong>Локация:</strong> Иссык-Кульская область, Жети-Огузский Кызыл- Суу АО, уч. Кара -Булун<br />
      </p>
      </div>
    `,
  },

  {
    latitude:40.4736994,
   longitude: 72.710097,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Тойчиев Марат</h3>
      <p style="margin: 4px 0;">
        <strong>Наименование культур:</strong> Фрукты<br />
        <strong>Наименование вида:</strong>яблоки и черешня <br />
        <strong>Площадь питомника, га:</strong> 10,5<br />
        <strong>Локация:</strong>Ош обл, Кара -Сууйский район, Жапалак АО, массив Кен-Сай<br />
      </p>
      </div>
    `,
  },

  {
    latitude: 40.4789514,
   longitude: 72.8255991,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Баймырзаев Дильмурад</h3>
      <p style="margin: 4px 0;">
        <strong>Наименование культур:</strong> Фрукты<br />
        <strong>Наименование вида:</strong>яблоки, персик и клубника <br />
        <strong>Площадь питомника, га:</strong> 10<br />
        <strong>Локация:</strong>Ошская область, Кара-Сууйский район, Толекан АО, с. Жаны-Турмуш<br />
      </p>
      </div>
    `,
  },

  {
    latitude: 40.3034315,
   longitude: 72.318087,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Сырынов Алмаз</h3>
      <p style="margin: 4px 0;">
        <strong>Наименование культур:</strong> Фрукты<br />
        <strong>Наименование вида:</strong>черешня, яблоки и персик <br />
        <strong>Площадь питомника, га:</strong> 15<br />
        <strong>Локация:</strong>Ошская область, Ноокатский район, Он- Эки Бел АО, с. Он-Эки Мойнок, Жаныкулов, 36<br />
      </p>
      </div>
    `,
  },

  {
    latitude: 40.2612914,
   longitude: 72.5773841,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">СХК «Ноокат алмасы»</h3>
      <p style="margin: 4px 0;">
        <strong>Наименование культур:</strong> Фрукты<br />
        <strong>Наименование вида:</strong>черешня, яблоки и персик <br />
        <strong>Площадь питомника, га:</strong> 17<br />
        <strong>Локация:</strong>Ошская область, Ноокатский район, Исанов АО, с. Байыш<br />
      </p>
      </div>
    `,
  },

  {
    latitude: 40.3034315,
   longitude: 72.318087,
    tooltip: `
      <div>
         <h3 style="margin-top: 0; margin-bottom: 8px; font-size: 16px; color: #333;">Ашмуратов Усон</h3>
      <p style="margin: 4px 0;">
        <strong>Наименование культур:</strong> Фрукты<br />
        <strong>Наименование вида:</strong>черешня, яблоки и персик <br />
        <strong>Площадь питомника, га:</strong> 16<br />
        <strong>Локация:</strong>Ошская область, Ноокатский район, Он-Эки- Бел АО, с. Он-Эки-Бел, ул. Калбаева, 21<br />
      </p>
      </div>
    `,
  },
];
const customMarkerIcon = L.icon({
  iconUrl: "/sad.svg",
  iconSize: [35, 55],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
});

export const NurseryMap = (props: IContentPart) => {
  (L as any).drawLocal = getCookie("i18next") === "ky" ? KyLokal : RuLokal;

  const [geoData, setGeoData] = useState<any>(null);
  const [bishkekGeoData, setBishkekGeoData] = useState<any>(null);
  const [batkenGeoData, setBatkenGeoData] = useState<any>(null);
  const [chuiGeoData, setChuiGeoData] = useState<any>(null);
  const [issikulGeoData, setIssikulGeoData] = useState<any>(null);
  const [jalalabadGeoData, setJalalabadGeoData] = useState<any>(null);
  const [narinGeoData, setNarinGeoData] = useState<any>(null);
  const [oshGeoData, setOshGeoData] = useState<any>(null);
  const [oshoblGeoData, setOshoblGeoData] = useState<any>(null);
  const [talasGeoData, setTalasGeoData] = useState<any>(null);
  useEffect(() => {
    const fetchGeoData = async (
      file: string,
      setGeoData: React.Dispatch<React.SetStateAction<any>>,
      label: string
    ) => {
      try {
        const response = await fetch(`/${file}`);
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        const data = await response.json();
        if (data[0] && data[0].geojson) {
          setGeoData(data[0].geojson);
        } else {
          console.warn(
            `Данные geojson отсутствуют или неверный формат в ${label}:`,
            data
          );
        }
      } catch (error) {
       
      }
    };

  

    fetchGeoData("polygons/search.json", setGeoData, "polygons/search.json");
    fetchGeoData(
      "polygons/bishkek.json",
      setBishkekGeoData,
      "polygons/bishkek.json"
    );
    fetchGeoData(
      "polygons/batken.json",
      setBatkenGeoData,
      "polygons/batken.json"
    );
    fetchGeoData("polygons/chui.json", setChuiGeoData, "polygons/chui.json");
    fetchGeoData(
      "polygons/issikul.json",
      setIssikulGeoData,
      "polygons/issikul.json"
    );
    fetchGeoData(
      "polygons/jalalabad.json",
      setJalalabadGeoData,
      "polygons/jalalabad.json"
    );
    fetchGeoData("polygons/narin.json", setNarinGeoData, "polygons/narin.json");
    fetchGeoData("polygons/osh.json", setOshGeoData, "polygons/osh.json");
    fetchGeoData(
      "polygons/oshobl.json",
      setOshoblGeoData,
      "polygons/oshobl.json"
    );
    fetchGeoData("polygons/talas.json", setTalasGeoData, "polygons/talas.json");
  }, []);

  const getStyle = (color: string) => ({
    color: color,
    weight: 2,
    opacity: 1,
    fillOpacity: 0.5,
  });

  const onEachFeature = (feature: any, layer: any) => {
    layer.on({
      mouseover: (e: any) => {
        e.target.setStyle({
          weight: 4,
          fillOpacity: 0.7,
        });
      },
      mouseout: (e: any) => {
        e.target.setStyle({
          weight: 2,
          fillOpacity: 0.5,
        });
      },
    });
  };

  return (
    <MapContainer
      className={styles.map}
      center={[41.5089324, 74.724091]}
      zoom={7}
      minZoom={7}
      scrollWheelZoom={true}
      zoomControl={false}
    >
    <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      {/* {geoData && (
        <GeoJSON
          data={geoData}
          style={getStyle("blue")}
          onEachFeature={onEachFeature}
        />
      )} */}

      {markers.map((marker, index) => (
        <Marker
          key={index}
          position={[marker.latitude, marker.longitude]}
          icon={customMarkerIcon}
        >
          <Popup>
            <div dangerouslySetInnerHTML={{ __html: marker.tooltip }} />
          </Popup>
        </Marker>
      ))}
           {/* {geoData && <GeoJSON data={geoData} style={getStyle('grey')} onEachFeature={onEachFeature} />} */}
           {bishkekGeoData && <GeoJSON data={bishkekGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {batkenGeoData && <GeoJSON data={batkenGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {chuiGeoData && <GeoJSON data={chuiGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {issikulGeoData && <GeoJSON data={issikulGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {jalalabadGeoData && <GeoJSON data={jalalabadGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {narinGeoData && <GeoJSON data={narinGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {/* {oshGeoData && <GeoJSON data={oshGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />} */}
      {oshoblGeoData && <GeoJSON data={oshoblGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
      {talasGeoData && <GeoJSON data={talasGeoData} style={getStyle('#AAA9A9')} onEachFeature={onEachFeature} />}
    </MapContainer>
  );
};
